import React from 'react';

const FACEBOOK_URL = 'https://www.facebook.com/theScore';

class FacebookPageBox extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined' && window.FB) window.FB.XFBML.parse();
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined' && window.FB) window.FB.XFBML.parse();
  }

  render() {
    return (
      <div>
        <div className="facebook-page-box">
          <div
            className="fb-page"
            data-href={FACEBOOK_URL}
            data-width="320"
            data-small-header="true"
            data-hide-cover="false"
            data-show-facepile="true"
            data-show-posts="false"
          >
            <div className="fb-xfbml-parse-ignore">
              <blockquote cite={FACEBOOK_URL}>
                <a href={FACEBOOK_URL}>TheScore</a>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FacebookPageBox;
